import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import vmodal from 'vue-js-modal';
import {getAuth, onAuthStateChanged} from "firebase/auth";
import store from "./store/index.js";
import Vuetify from "vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import wb from "./registerServiceWorker";
import VueQrcodeReader from "vue-qrcode-reader";
import './../assets/index.scss'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';


Vue.use(VueToast);
Vue.use(vmodal)

require('firebase/storage')

Vue.use(VueQrcodeReader);
Vue.prototype.$workbox = wb;
Vue.use(Vuetify);
Vue.config.productionTip = false;
let app;
const auth = getAuth();
onAuthStateChanged(auth, (user) => {
    store.dispatch("userAuthStateChanged", user);
    if (!app) {
        app = new Vue({
            router,
            vuetify: new Vuetify(),
            store,
            // QrReader,
            render: (h) => h(App),
        }).$mount("#app");
    }
});